import { Component, OnInit, Input } from '@angular/core';

@Component({
  selector: 'app-front-banner',
  templateUrl: './front-banner.component.html',
  styleUrls: ['./front-banner.component.scss']
})
export class FrontBannerComponent implements OnInit {

  @Input() contentData: any;

  constructor() { }

  ngOnInit(): void {
  }

}
